/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Format_8x11_PremiumInputs */

const en_format_8x11_premium = /** @type {(inputs: Format_8x11_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8×11 Premium Format`)
};

const es_format_8x11_premium = /** @type {(inputs: Format_8x11_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato Premium 8x11`)
};

const fr_format_8x11_premium = /** @type {(inputs: Format_8x11_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format Premium 8x11`)
};

const de_format_8x11_premium = /** @type {(inputs: Format_8x11_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8×11 Premium Format`)
};

const ja_format_8x11_premium = /** @type {(inputs: Format_8x11_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレミアムフォーマット 8x11`)
};

const zh_format_8x11_premium = /** @type {(inputs: Format_8x11_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高级格式 8×11`)
};

const ar_format_8x11_premium = /** @type {(inputs: Format_8x11_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنسيق 8×11 Premium`)
};

const id_format_8x11_premium = /** @type {(inputs: Format_8x11_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format Premium 8×11`)
};

const it_format_8x11_premium = /** @type {(inputs: Format_8x11_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato Premium 8x11`)
};

const ru_format_8x11_premium = /** @type {(inputs: Format_8x11_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премиум Формат 8×11`)
};

const pt_format_8x11_premium = /** @type {(inputs: Format_8x11_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato Premium 8×11`)
};

const ko_format_8x11_premium = /** @type {(inputs: Format_8x11_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프리미엄 포맷 8×11`)
};

/**
* | output |
* | --- |
* | "8×11 Premium Format" |
*
* @param {Format_8x11_PremiumInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const format_8x11_premium = /** @type {((inputs?: Format_8x11_PremiumInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Format_8x11_PremiumInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_format_8x11_premium(inputs)
	if (locale === "es") return es_format_8x11_premium(inputs)
	if (locale === "fr") return fr_format_8x11_premium(inputs)
	if (locale === "de") return de_format_8x11_premium(inputs)
	if (locale === "ja") return ja_format_8x11_premium(inputs)
	if (locale === "zh") return zh_format_8x11_premium(inputs)
	if (locale === "ar") return ar_format_8x11_premium(inputs)
	if (locale === "id") return id_format_8x11_premium(inputs)
	if (locale === "it") return it_format_8x11_premium(inputs)
	if (locale === "ru") return ru_format_8x11_premium(inputs)
	if (locale === "pt") return pt_format_8x11_premium(inputs)
	return ko_format_8x11_premium(inputs)
});